import { NotificationIcon } from 'icons';
import { FormattedMessage } from 'localization';

import { EnumDeskRoutes, EnumNotificationsRoutes, EnumSettingRoutes } from '../../../constants';
import { SettingsSidebarMenuItem } from '../AdminSettingsSidebar';

const notificationsSection: SettingsSidebarMenuItem = {
  icon: <NotificationIcon width={24} height={24} />,

  data: [
    {
      value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.notifications}/${EnumNotificationsRoutes.configuration}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="desk-app.configuration" />
        </div>
      ),
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.notifications}/${EnumNotificationsRoutes.touchPoints}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="settings.touch-points" />
        </div>
      ),
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.notifications}/${EnumNotificationsRoutes.reviewBooster}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="settings.emails-form.label.review_booster" />
        </div>
      ),
    },
    {
      value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.notifications}/${EnumNotificationsRoutes.hyperNotifications}`,
      label: (
        <div className="capitalize">
          <FormattedMessage id="settings.hyper-notifications" />
        </div>
      ),
    },
  ],
  translationKey: 'general.notifications',
};

export { notificationsSection };
